import { FETCH_MODULE_SCHEMAS_SUCCEEDED, FETCH_CONTENT_SCHEMA_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
import { combineModuleSchemasWithDynamicFilter } from 'ContentEditorUI/data/ModuleTransforms';
const isSchemaHubspotModule = module => {
  return Boolean(module.path && module.path.startsWith('@hubspot/'));
};
const moduleSchemasInitialState = {
  all: {},
  allAddable: {},
  builtinMapping: {},
  builtInModules: {},
  categoryName: null,
  customModules: {},
  globalModules: {},
  globalGroupInfo: {},
  globalPartialInfo: {}
};
const moduleSchemaReducer = (state = moduleSchemasInitialState, data = {
  type: '',
  response: {}
}) => {
  const {
    type,
    response
  } = data;
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const contentSchemaResponse = response;
        const {
          used_module_schemas: usedModuleSchemas
        } = contentSchemaResponse;
        let categoryName = state.categoryName;
        if (!categoryName) {
          categoryName = contentSchemaResponse.categoryName;
          state = Object.assign({}, state, {
            categoryName
          });
        }
        state = combineModuleSchemasWithDynamicFilter({
          categoryName,
          existingAllModulesMap: state.all,
          existingAllAddableMap: state.allAddable,
          existingBuiltInModulesMap: state.builtInModules,
          existingGlobalModulesMap: state.globalModules,
          existingCustomModulesMap: state.customModules,
          usedModuleSchemas,
          canAddToAddableMap: false
        }, state, isSchemaHubspotModule);
        return Object.assign({}, state, {
          builtinMapping: response.builtin_mapping,
          globalGroupInfo: response.schema.global_group_info_by_path,
          globalPartialInfo: response.schema.global_partial_info_by_path
        });
      }
    case FETCH_MODULE_SCHEMAS_SUCCEEDED:
      {
        return combineModuleSchemasWithDynamicFilter(Object.assign({
          existingAllModulesMap: state.all,
          existingAllAddableMap: state.allAddable,
          existingBuiltInModulesMap: state.builtInModules,
          existingGlobalModulesMap: state.globalModules,
          existingCustomModulesMap: state.customModules
        }, response), state, isSchemaHubspotModule);
      }
    default:
      return state;
  }
};
export default moduleSchemaReducer;